import { render, staticRenderFns } from "./Property.vue?vue&type=template&id=2845324e&scoped=true&"
import script from "./Property.vue?vue&type=script&lang=js&"
export * from "./Property.vue?vue&type=script&lang=js&"
import style0 from "../index.scss?vue&type=style&index=0&id=2845324e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2845324e",
  null
  
)

export default component.exports